webpackJsonp([217196528603516],{

/***/ 941:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0040_colossus.jpg","type":"Unit","subtype":"Golem","cost":6,"ATK":6,"HP":7,"rules_text_1":"Unstoppable when attacking a base.","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Colossus","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":null,"color":"White","spec":"Strength","bottom":"Tech II","rulings":[],"keywords":["Unstoppable"],"slug":"colossus"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"colossus","keywords":["Unstoppable"],"imageRegex":"/colossus.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-colossus-2ce2cecf01c50e79701c.js